<script setup>
defineProps({
    event: {
        type: Object,
        required: true,
    },
})
</script>

<template>
    <section class="mural-events">
        <header class="mural-events__header">
            <h2>{{ $t('components.rhdigital.mural.events.title') }}</h2>
            <span>{{ event.date }}</span>
        </header>

        <article class="mural-events__item">
            <h3>{{ event.title }}</h3>
            <p>
                <span class="material-symbols-outlined">schedule</span>
                {{ event.time }}
            </p>
        </article>

        <button class="mural-events__details" type="button" v-tooltip="$t('common.labels.availableSoon')">
            {{ $t('components.rhdigital.mural.events.details') }}
        </button>
    </section>
</template>

<style lang="scss" scoped>
.mural-events {
    padding: 22px 20px;
    border: 1px solid #dde5f3;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 12px 30px rgba(34, 48, 73, 0.04);

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 14px;
        margin-bottom: 18px;

        h2 {
            margin: 0;
            color: #2f3b52;
            font-size: 17px;
            font-weight: 800;
        }

        span {
            color: #625bf6;
            font-size: 12px;
            font-weight: 800;
            white-space: nowrap;
        }
    }

    &__item {
        padding: 14px 12px;
        border: 1px solid #dce5f5;
        border-radius: 8px;
        background: #f8faff;

        h3 {
            margin: 0;
            color: #334159;
            font-size: 14px;
            font-weight: 800;
        }

        p {
            display: flex;
            align-items: center;
            gap: 6px;
            margin: 8px 0 0;
            color: #8ea0bb;
            font-size: 13px;
            font-weight: 500;
        }

        .material-symbols-outlined {
            font-size: 16px;
        }
    }

    &__details {
        width: 100%;
        height: 32px;
        margin-top: 16px;
        border: 0;
        border-radius: 8px;
        background: #efefff;
        color: #625bf6;
        font-size: 13px;
        font-weight: 800;
        cursor: default;
    }
}

.dark-theme {
    .mural-events {
        border-color: var(--borderColor);
        background: #0c1427;
        box-shadow: none;

        &__header {
            h2 {
                color: var(--whiteColor);
            }

            span {
                color: #9d98ff;
            }
        }

        &__item {
            border-color: var(--borderColor);
            background: #15203c;

            h3 {
                color: var(--whiteColor);
            }

            p {
                color: var(--bodyColor);
            }
        }

        &__details {
            background: rgba(98, 91, 246, 0.16);
            color: #9d98ff;
        }
    }
}
</style>
